module.exports = __webpack_public_path__ + "282850ff727c1d74451b8a79534d6a1c.pdf";